export default __webpack_public_path__ + "static/media/unmute-icon-new.3719d4a8.svg";